import {
	default as React,
	type ReactNode,
	createContext,
	useContext,
} from "react";
import { useComplexState } from "use-complex-state";
import { UTLSettingsReducer } from "../reducers/UTLSettingsReducer";

const UTLSettingsContext = createContext({
	state: UTLSettingsReducer.getInitialState(),
	actions: UTLSettingsReducer.actions,
});

export const useUTLSettingsContext = () => useContext(UTLSettingsContext);

export const UTLSettingsProvider = ({ children }: { children: ReactNode }) => {
	const [state, actions] = useComplexState({
		initialState: UTLSettingsReducer.getInitialState(),
		reducers: UTLSettingsReducer.caseReducers,
	});

	return (
		<UTLSettingsContext.Provider value={{ state, actions }}>
			{children}
		</UTLSettingsContext.Provider>
	);
};
